import { Link, Stack, Typography, useTheme } from "@mui/material";
import { BuildingIcon, LockIcon } from "../../icons";
import { castZero, RouterLink } from "../../../lib";
import { StartCwTimerButton } from "../../buttons";
import { GetTaskApiResponse } from "../../../state/rtk-query/state/tasks";
import { useCurOrg } from "../../hooks";
import { useSelector } from "react-redux";
import { authSelectors } from "../../../state";

interface Props {
  orgId?: number;
  taskId?: number;
  taskTimeSpent?: number | null;
  type?: GetTaskApiResponse["type"];
  taskCode?: string;
  taskTitle?: string;
}
export const TimerBanner = ({
  orgId,
  taskId,
  type,
  taskCode,
  taskTitle,
  taskTimeSpent,
}: Props) => {
  const { palette } = useTheme();
  const orgInfo = useCurOrg(orgId);
  const isInternalTask = type === "internal_task";
  const isInternal = useSelector(authSelectors.isInternal);
  if (!taskId) return null;

  return (
    <Stack
      p={"20px 32px"}
      sx={{
        bgcolor: isInternalTask ? palette.warning[100] : palette.primary[100],
      }}
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <Stack direction={"row"} alignItems={"center"}>
        {isInternalTask ? <LockIcon size={18} /> : <BuildingIcon size={18} />}
        <Link
          to={`/organizations/${orgInfo?.id}`}
          component={RouterLink}
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            ml: 2,
          }}
          color={palette.grey[900]}
        >
          {orgInfo?.name}
        </Link>
        {orgInfo?.server_name && isInternal && (
          <Typography variant="subtitle2" fontSize={10} fontWeight={600} px={1}>
            {orgInfo?.server_name}
          </Typography>
        )}
      </Stack>

      <StartCwTimerButton
        type={type}
        taskTimeSpent={taskTimeSpent}
        orgId={castZero(orgId)}
        taskId={castZero(taskId)}
        taskCode={taskCode ?? ""}
        taskTitle={taskTitle ?? ""}
      />
    </Stack>
  );
};
